import { createFileRoute } from '@tanstack/react-router'
import AdminImpersonatePage from '@/components/pages/AdminImpersonatePage/AdminImpersonatePage'
import { z } from 'zod/v4'

// returnTo must be an internal absolute path (leading single "/"); reject
// protocol-relative ("//") and absolute URLs so a crafted impersonate URL
// can't redirect the admin off-site on exit.
const internalPath = z
  .string()
  .max(2048)
  .regex(/^\/(?!\/)/, 'returnTo must be an internal path')

const impersonateSearchSchema = z.object({
  token: z.string().optional(),
  returnTo: internalPath.optional(),
})

export const Route = createFileRoute('/admin/impersonate')({
  validateSearch: (search) => impersonateSearchSchema.parse(search),
  component: ImpersonateRoute,
})

function ImpersonateRoute() {
  return <AdminImpersonatePage />
}
